// Runtime analytics/verification injector.
// Reads env vars at build time so IDs can be added later without touching JSX.
//   REACT_APP_GA_ID       — Google Analytics 4 measurement ID (G-XXXXXXXXXX)
//   REACT_APP_GSC_VERIFY  — Google Search Console verification token
//   REACT_APP_BING_VERIFY — Bing Webmaster Tools verification token
//   REACT_APP_CLARITY_ID  — Microsoft Clarity project ID

const injectMeta = (name, content) => {
  if (!content) return;
  if (document.querySelector(`meta[name="${name}"]`)) return;
  const m = document.createElement("meta");
  m.name = name;
  m.content = content;
  document.head.appendChild(m);
};

const injectScript = (id, src, inline) => {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.id = id;
  s.async = true;
  if (src) s.src = src;
  if (inline) s.text = inline;
  document.head.appendChild(s);
};

export function initAnalytics() {
  const GA = process.env.REACT_APP_GA_ID;
  const GSC = process.env.REACT_APP_GSC_VERIFY;
  const BING = process.env.REACT_APP_BING_VERIFY;
  const CLARITY = process.env.REACT_APP_CLARITY_ID;

  injectMeta("google-site-verification", GSC);
  injectMeta("msvalidate.01", BING);

  if (GA) {
    injectScript("ga-loader", `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA)}`);
    injectScript(
      "ga-init",
      null,
      `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${GA}',{anonymize_ip:true});`
    );
  }

  if (CLARITY) {
    injectScript(
      "ms-clarity",
      null,
      `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window,document,"clarity","script","${CLARITY}");`
    );
  }
}
